<template>
  <div>
    <!--    <tableau-viz v-if="embedUrl" id='tableau-viz'-->
    <!--                 :src="embedUrl"-->
    <!--                 :token="token"-->
    <!--                 height="100%"-->
    <!--    ></tableau-viz>-->
    <!--    -->
    <div class="tableau-view-container" ref="tableauViewContainer"></div>

  </div>
</template>

<script>
import {TableauViz, TableauEventType, TableauDialogType} from '@tableau/embedding-api';
// import {TableauViz} from '@tableau/embedding-api';

export default {
  name: "Report",
  props: {
    embedUrl: String,
    token: String
  },
  data() {
    return {
      tableauViz: null,
    }
  },
  watch: {
    embedUrl(url) {
      if (url) {
        this.loadReport(url);
      }
    }
  },
  methods: {
    loadReport(url) {
      if (this.tableauViz)
        this.tableauViz.remove();

      const viz = new TableauViz();
      viz.src = url;
      viz.token = this.token;
      viz.toolbar = 'top';
      // viz.toolbar = 'hidden';
      viz.addEventListener(TableauEventType.FirstInteractive, this.handleFirstInteractive);
      const view = this.$refs.tableauViewContainer;
      view.appendChild(viz);
      this.tableauViz = viz;
    },
    handleFirstInteractive() {
      this.$emit('reportLoaded');
    },
    async initiateExport() {
      const tableauViz = this.tableauViz;
      if(tableauViz) {
        await tableauViz.displayDialogAsync(TableauDialogType.ExportCrossTab);
      }
    }
  }
}
</script>


<style scoped>
.tableau-view-container {
  height: calc(100vh - 64px - 1em);
}
</style>